import { useQuery } from 'react-query';

import api from '@root/api';

export default function useLatestAIImages({ documentId, enabled }) {
  return useQuery(['documentImage.getLatestAiImages', documentId], () => api.documentImages.getLatestAiImages(documentId), { enabled });
}
